<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="待补货单"> </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:otherOperations>
        <div style="display: flex; align-items: center">
          <el-button
            size="small"
            type="primary"
            @click="generateReplenishmentOrder"
            >生成补货单</el-button
          >
        </div>
      </template>
      <template v-slot:need_num="row">
        <div style="display: flex; align-items: center">
          <el-input
            v-model="row.row.need_num"
            placeholder=""
            size="small"
            style="width: 80px"
          ></el-input>
          <span style="margin-left: 8px; color: #606266; font-size: 12px">
            {{ getPackageCount(row.row) }}
          </span>
        </div>
      </template>
      <template v-slot:is_below_safe_stock="row">
        <el-tag :type="row.row.is_below_safe_stock ? 'danger' : 'success'" size="small">
          {{ row.row.is_below_safe_stock ? '是' : '否' }}
        </el-tag>
      </template>
      <template v-slot:suppliernum="row">
        <el-link @click="viewSuppliers(row.row)" type="primary"
          >{{ row.row.suppliernum }}家</el-link
        >
      </template>
    </basicList>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="1200px"
      custom-class="dialogCenter"
      @close="close"
    >
      <basicList :config="detailsConfiguration"> </basicList>
    </el-dialog>
    <!-- 补货确认弹窗 -->
    <el-dialog
      title="补货确认"
      :visible.sync="confirmDialog.visible"
      width="1100px"
      :close-on-click-modal="false"
    >
      <el-table :data="confirmDialog.data" border size="small" max-height="450">
        <el-table-column prop="item_number" label="编码" width="140" />
        <el-table-column prop="name" label="品名" min-width="160" />
        <el-table-column prop="num" label="当前库存" width="90" />
        <el-table-column prop="item_stock_target" label="目标库存" width="90" />
        <el-table-column prop="item_stock_safe" label="安全库存" width="90" />
        <el-table-column label="推荐补货" width="100" align="center">
          <template slot-scope="scope">{{ scope.row.recommend_num }}</template>
        </el-table-column>
        <el-table-column label="确认数量" width="220" align="center">
          <template slot-scope="scope">
            <div style="display:flex;align-items:center;gap:4px">
              <el-input-number
                v-model="scope.row.need_num"
                :min="0"
                size="small"
                controls-position="right"
                style="width:120px"
              />
              <span style="color:#909399;font-size:12px;white-space:nowrap">({{ Math.floor((scope.row.need_num || 0) / (scope.row.in_package_num || 1)) }}箱)</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="confirmDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="confirmReplenish">确认并生成补货单</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="选择供应商"
      :visible.sync="supplierDialogVisible"
      width="400px"
      append-to-body
    >
      <el-form>
        <el-form-item label="供应商">
          <el-select v-model="selectedSupplierId" filterable placeholder="请选择供应商" style="width: 100%">
            <el-option
              v-for="item in supplierlist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="supplierDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmGeneratePreOrder">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getRoles } from "@/utils";
import {
  itemClassGetList,
  getshoplist,
  supplierGetList,
} from "@/api/basicConfiguration";
import {
  getListSupplier,
  getSupplierList,
  getReplenishRecommend,
} from "@/api/pendingReplenishmentOrder";
import { preOrderBuyAdd } from "@/api/purchasing";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "pendingReplenishmentOrder",
  data() {
    return {
      supplierDialogVisible: false,
      selectedSupplierId: null,
      supplierlist: [],
      confirmDialog: {
        visible: false,
        data: [],
      },
      pendingLogDiffs: null,
      shopId: null,
      detailsConfiguration: {
        loading: false,
        height: "calc(100vh - 350px)",
        search: false,
        data: [],
        column: [
          {
            label: "供应商名称",
            prop: "supplier_name",
          },
          {
            label: "最近供货价",
            prop: "last_purchase_price",
            isMoney: true,
          },
          {
            label: "最近采购价",
            prop: "avg_price",
            isMoney: true,
          },
          {
            label: "差价",
            prop: "diff_price",
            isMoney: true,
          },
          {
            label: "采购次数",
            prop: "purchase_count",
            width: 100,
          },
          {
            label: "供货级别",
            prop: "level",
          },
          {
            label: "上次供货天数",
            prop: "last_supply_days",
          },
        ],
        isPage: false,
        operation: false,
        total: 0,
        searchParameters: {},
      },
      // 列表组件参数
      basicListconfig: {
        check: true,
        loading: false,
        height: "calc(100vh - 350px)",
        search: [
          {
            label: "所属门店",
            type: "select",
            options: [],
            key: "shop_id",
            value: "",
          },
          {
            label: "商品分类",
            type: "treeselect",
            options: [],
            key: "class_id",
          },
          {
            label: "指定供应商",
            type: "select",
            options: [],
            key: "supplier_id",
            filterable: true,
            clearable: true,
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
        ],
        data: [],
        column: [
          {
            label: "门店",
            prop: "shopname",
            width: 150,
          },
          {
            label: "品名",
            prop: "name",
            width: 300,
          },
          {
            label: "当前库存",
            prop: "num",
            width: 100,
          },
          {
            label: "目标库存",
            prop: "item_stock_target",
            width: 100,
          },
          {
            label: "补货量",
            prop: "need_num",
            slot: true,
            width: 180,
          },{
            label: "箱规",
            prop: "in_package_num",
            width: 100,
          },
          {
            label: "最新采购价",
            prop: "price_new",
            width: 150,
          },
          {
            label: "低于安全库存",
            prop: "is_below_safe_stock",
            slot: true,
            width: 150,
          },
          {
            label: "供应商",
            prop: "suppliernum",
            slot: true,
            width: 200,
          },
        ],
        isPage: true,
        operation: false,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      title: "",
      visible: false,
      storeList: [],
      selectedData: [],
    };
  },
  created() {
    // 设置行样式类名函数
    this.basicListconfig.rowClassName = this.tableRowClassName;
    
    this.getDataSource().then((res) => {
      // 有主门店直接查询主门店下数据;
      if (this.$store.getters.userInfo.shopId) {
        // 搜索框赋值
        this.basicListconfig.search.map((item) => {
          if (item.key == "shop_id") {
            item.value = this.$store.getters.userInfo.shopId;
          }
          return item;
        });
        // 没有主门店手动选择门店可查看;
        this.basicListconfig.searchParameters.shop_id = Number(
          this.$store.getters.userInfo.shopId
        );
        this.getlist();
      } else {
        this.$message.error("本账号没有主门店，需要手动选择一个门店！");
      }
    });
  },
  methods: {
    // 计算箱数量显示
    getPackageCount(row) {
      const needNum = row.need_num || 0;
      const packageNum = row.in_package_num || 1;
      const boxCount = Math.floor(needNum / packageNum);
      return `（${boxCount}箱）`;
    },
    // 表格行样式
    tableRowClassName({ row, rowIndex }) {
      if (row.is_below_safe_stock) {
        return 'warning-row';
      }
      return '';
    },
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    generateReplenishmentOrder() {
      let exportData = [];
      if (this.selectedData.length == 0) {
        exportData = this.basicListconfig.data;
        if (exportData.length == 0) {
          this.$message.error("没有可导出的数据！");
          return;
        }
      } else {
        exportData = this.selectedData;
      }

      const itemIds = exportData.map(item => item.item_id || item.id).filter(Boolean);

      // 查询历史推荐补货量
      const loadRecommend = itemIds.length
        ? getReplenishRecommend({ item_ids: itemIds.join(',') }).then(res => res.code === 1 ? res.data : []).catch(() => [])
        : Promise.resolve([]);

      loadRecommend.then(recommendMap => {
        this.confirmDialog.data = exportData.map(item => {
          const id = item.item_id || item.id;
          const rec = recommendMap.find(r => String(r.item_id) === String(id));
          return {
            ...item,
            calc_need_num: item.need_num || 0,
            recommend_num: rec ? rec.final_need : (item.need_num || 0),
            need_num: rec ? rec.final_need : (item.need_num || 0),
          };
        });
        this.confirmDialog.visible = true;
      });
    },

    confirmReplenish() {
      const data = this.confirmDialog.data;
      const diffs = data
        .filter(item => Number(item.need_num) !== Number(item.calc_need_num))
        .map(item => ({
          item_id: item.id || item.item_id,
          item_number: item.item_number,
          name: item.name,
          shop_id: this.selectShop,
          current_num: item.num,
          target: item.item_stock_target || 0,
          safe: item.item_stock_safe || 0,
          calc_need: item.calc_need_num,
          final_need: item.need_num,
        }));

      this.pendingLogDiffs = diffs;

      this.confirmDialog.visible = false;
      if (this.selectedData.length == 0) {
        this.basicListconfig.data.forEach((item, idx) => {
          if (data[idx]) item.need_num = data[idx].need_num;
        });
      } else {
        this.selectedData.forEach((item, idx) => {
          if (data[idx]) item.need_num = data[idx].need_num;
        });
      }

      this.supplierDialogVisible = true;
    },

    generateExcelFile() {
      let exportData = [];
      if (this.selectedData.length == 0) {
        exportData = this.basicListconfig.data;
      } else {
        exportData = this.selectedData;
      }
      
      const headers = [
        "序号",
        "编码",
        "品名",
        "数量",
        "单位",
      ];
      
      // 生成HTML表格
      let html = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">';
      html += '<head><meta charset="utf-8">';
      html += '<style>';
      html += 'table {border-collapse: collapse; width: auto;}';
      html += 'th {border: 2px solid #000; padding: 20px 15px; text-align: center; font-size: 16px; font-weight: bold; background-color: #f0f0f0;}';
      html += 'td {border: 1px solid #000; padding: 18px 15px; text-align: center; font-size: 14px; height: 50px;}';
      html += 'td:first-child {width: 60px;}';
      html += 'td:nth-child(2) {text-align: left; width: 300px; mso-number-format:"@";}';
      html += 'td:nth-child(3) {width: 80px;}';
      html += 'td:nth-child(4) {width: 60px;}';
      html += '</style>';
      html += '</head>';
      html += '<body><table>';
      
      // 添加表头
      html += '<thead><tr>';
      headers.forEach(header => {
        html += '<th>' + header + '</th>';
      });
      html += '</tr></thead>';
      
      // 添加数据行
      html += '<tbody>';
      exportData.forEach((row, index) => {
        html += '<tr>';
        // 序号
        html += '<td>' + (index + 1) + '</td>';
        // 编码
        html += "<td x:str style='mso-number-format:\"@\"'>" + (row.item_number ? (String(row.item_number)) : "") + "</td>";
        // 品名
        html += '<td>' + (row.name || "") + '</td>';
        // 数量（补货量/件内数）
        let needNum = row.need_num || 0;
        let packageNum = row.in_package_num || 1;
        let quantity = Math.ceil(needNum / packageNum);
        html += '<td>' + quantity + '</td>';
        // 单位
        html += '<td>件</td>';
        html += '</tr>';
      });
      html += '</tbody>';
      html += '</table></body></html>';
      
      // 创建下载链接
      const blob = new Blob(["\ufeff" + html], {
        type: "application/vnd.ms-excel;charset=utf-8"
      });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      
      link.setAttribute("href", url);
      link.setAttribute("download", "补货单_" + new Date().getTime() + ".xls");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      // 同时复制文本到剪贴板
      this.copyTextToClipboard(exportData);
      
      this.$message.success("补货单生成成功，文本已复制到剪贴板！");

      // 询问是否生成预采购单
      this.$confirm('补货单已导出，是否继续生成预采购单？', '提示', {
          confirmButtonText: '生成预采购单',
          cancelButtonText: '跳过',
          type: 'info'
        }).then(() => {
          // 如果搜索栏已经选择了供应商，则默认选中
          if (this.basicListconfig.searchParameters.supplier_id) {
             this.selectedSupplierId = this.basicListconfig.searchParameters.supplier_id;
          } else {
             this.selectedSupplierId = null;
          }
          this.supplierDialogVisible = true;
        }).catch(() => {
          // 取消则不做任何操作
        });
    },
    // 复制文本到剪贴板
    copyTextToClipboard(data) {
      let textContent = "";
      
      data.forEach((row) => {
        let name = row.name || "";
        let needNum = row.need_num || 0;
        let packageNum = row.in_package_num || 1;
        let quantity = Math.ceil(needNum / packageNum);
        
        textContent += name + "*" + quantity + "件\n";
      });
      
      textContent += "麻烦帮忙安排一下";
      
      // 复制到剪贴板
      if (navigator.clipboard && navigator.clipboard.writeText) {
        // 现代浏览器方法
        navigator.clipboard.writeText(textContent).then(() => {
          console.log("文本已复制到剪贴板");
        }).catch((err) => {
          console.error("复制失败:", err);
          this.fallbackCopyTextToClipboard(textContent);
        });
      } else {
        // 兼容旧浏览器
        this.fallbackCopyTextToClipboard(textContent);
      }
    },
    // 兼容旧浏览器的复制方法
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.opacity = "0";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        const successful = document.execCommand("copy");
        if (successful) {
          console.log("文本已复制到剪贴板（兼容模式）");
        } else {
          console.error("复制失败");
        }
      } catch (err) {
        console.error("复制异常:", err);
      }
      
      document.body.removeChild(textArea);
    },
    confirmGeneratePreOrder() {
        if (!this.selectedSupplierId) {
            this.$message.warning("请选择供应商");
            return;
        }
        
        let targetData = [];
        if (this.selectedData.length == 0) {
            targetData = this.basicListconfig.data;
        } else {
            targetData = this.selectedData;
        }
        
        if (targetData.length == 0) {
             this.$message.error("没有可生成的数据！");
             return;
        }

        this.supplierDialogVisible = false;

        // 生成Excel并导出
        this.generateExcelFile();

        // 询问是否继续生成预采购单
        this.$confirm('补货单已导出，是否继续生成预采购单？', '提示', {
          confirmButtonText: '生成预采购单',
          cancelButtonText: '跳过',
          type: 'info'
        }).then(() => {
          this.createPreOrder(targetData, this.selectedSupplierId);
        }).catch(() => {});
    },

    createPreOrder(items, supplierId) {
      const shopId = this.basicListconfig.searchParameters.shop_id;
      const userId = this.$store.getters.userInfo.userId;
      const compId = this.$store.getters.userInfo.compId;

      // 构造 order_list
      const orderList = items.map(item => {
        const needNum = Number(item.need_num) || 0;
        const packageNum = Number(item.in_package_num) || 1;
        // 以 price_new 为准，元 ×100 转分
        const price = (Number(item.price_new) || 0) * 100;
        
        // 计算箱数和散数
        const boxCount = Math.floor(needNum / packageNum);
        const singleCount = needNum % packageNum;
        
        const totalMoney = needNum * price;

        return {
          item_id: item.item_id,
          num: needNum,
          package_num: boxCount,
          single_num: singleCount,
          price_new: price,
          avg_price: Number(item.avg_price) || 0,
          total_money: totalMoney,
          price_distribution: price, 
          price_outstock: 0
        };
      });

      // 计算总金额
      const totalMoney = orderList.reduce((sum, item) => sum + item.total_money, 0);

      const data = {
        order_info: {
          shop_id: shopId,
          comp_id: compId,
          supplier_id: supplierId,
          user_id: userId,
          num: orderList.reduce((sum, item) => sum + item.num, 0),
          trans_type: 0,
          total_money: totalMoney,
          payed_money: 0,
          remark: "由待补货单生成",
        },
        order_list: orderList,
        pay_list: [],
      };

      // 附上补货量差异日志
      if (this.pendingLogDiffs && this.pendingLogDiffs.length) {
        data.log_diffs = JSON.stringify(
          this.pendingLogDiffs.map(d => ({ ...d, supplier_id: supplierId }))
        );
        this.pendingLogDiffs = null;
      }

      preOrderBuyAdd(data).then(res => {
        if (res.code == 1) {
          this.$message.success("预采购单生成成功！");
          this.getlist();
          this.selectedData = [];
        } else {
          this.$message.error(res.msg || "生成失败");
        }
      });
    },
    // 查看供应商
    viewSuppliers(row) {
      this.title = "品名:" + row.name;
      this.visible = true;
      getSupplierList({ item_id: row.item_id }).then((res) => {
        this.detailsConfiguration.data = res.data.items.map((item) => {
          item.avg_price = res.data.item_info.avg_price;
          item.diff_price =
            item.last_purchase_price - res.data.item_info.avg_price;
          return item;
        });
      });
    },
    close() {
      this.visible = false;
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      localStorage.setItem("search", JSON.stringify(data));
      if (page || pageSize) {
        if (page) this.basicListconfig.searchParameters.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.search.map((item) => {
        if (item.key == "shop_id") {
          item.value = this.basicListconfig.searchParameters.shop_id;
        }
        return item;
      });
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters["comp_id"] = this.compId;
      getListSupplier(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 200) {
          this.basicListconfig.loading = false;
          const obj = this.storeList.find(
            (item) =>
              item.value == this.basicListconfig.searchParameters.shop_id
          );
          this.basicListconfig.data = res.data.data.map((item) => {
            item.shopname = obj.label;
            return item;
          });
          this.basicListconfig.total = res.data.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    async getDataSource() {
      const res = await getshoplist({
        status: 0,
        comp_id: JSON.parse(getRoles()).comp_id,
      });
      if (res.code == 1) {
        this.basicListconfig.search.map((item) => {
          if (item.key == "shop_id") {
            item.options = this.storeList = res.data.map((item) => {
              return {
                label: item.name,
                value: item.id,
              };
            });
          }
          return item;
        });
      } else {
        this.$message.error(res.msg);
      }
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
      supplierGetList({
        limit: 10000,
        comp_id: this.$store.getters.userInfo.compId,
        is_showAll: 1,
        user_id: this.$store.getters.userInfo.userId,
      }).then((res) => {
        console.log("供应商数据返回：", res);
        if (res.code == 1 || res.code == 200) {
          // 兼容不同的返回code值
          const supplierData = res.data || [];
          this.supplierlist = supplierData.map((item) => {
            return {
              label: item.id + "-" + item.nick_name,
              value: item.id,
            };
          });
          
          console.log("供应商列表：", this.supplierlist);
          
          // 将供应商列表添加到筛选条件中
          this.basicListconfig.search.forEach((item) => {
            if (item.key == "supplier_id") {
              item.options = this.supplierlist;
            }
          });
          
          // 强制更新视图
          this.$forceUpdate();
        } else {
          console.error("获取供应商失败，返回code:", res.code);
          this.$message.error(res.msg || res.data.msg || "获取供应商数据源失败！");
        }
      }).catch((error) => {
        console.error("获取供应商异常：", error);
        this.$message.error("获取供应商数据源异常！");
      });
    },
  },
};
</script>

<style>
.warning-row {
  background-color: #fef0f0 !important;
}
.warning-row:hover {
  background-color: #fde2e2 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/pendingReplenishmentOrder/index.vue